import { useState } from 'react';

interface FAQItem {
  question: string;
  answer: string;
}

const faqItems: FAQItem[] = [
  {
    question: 'Hitozuma 文化的定义是什么？',
    answer: 'Hitozuma 文化是指围绕日本语境中"人妻"（已婚女性）这一社会身份所形成的文化现象，涵盖文学、影视、动漫等多种媒介中的艺术表达、社会心理和文化符号。它不仅是大众文化的一个分支，也是日本社会结构和性别观念变迁的文化镜像。',
  },
  {
    question: 'Hitozuma 文化与一般成人内容有何区别？',
    answer: 'Hitozuma 文化作为一种文化研究领域，其核心关注点在于文化符号的解读、社会心理的分析以及艺术表达的研究。它强调的是文化深度和学术视角，而非单纯的感官刺激。本网站的内容也始终坚持专业、客观、学术化的立场。',
  },
  {
    question: '如何系统地了解 Hitozuma 文化？',
    answer: '建议从"基础入门"分类开始，阅读概念定义和文化概述类文章；然后可以进入"文化背景"分类，了解社会心理和历史渊源；之后可以选择"作品解析"和"分类盘点"，深入了解具体作品和类型特点；最后参考"资源索引"获取更多外部资源。',
  },
  {
    question: '本网站的内容来源是否可靠？',
    answer: '本网站的内容由专业编辑团队编写，参考了国内外学术研究、权威媒体评论和行业专家观点。所有文章均经过严格的审核流程，确保信息的准确性和观点的专业性。我们也会定期更新内容，反映最新的研究成果和文化动态。',
  },
  {
    question: '本网站是否适合所有年龄段的用户？',
    answer: '本网站的内容涉及对日本文化中特定主题的深度分析，部分讨论可能涉及成人视角。我们建议未成年用户在家长指导下浏览，并强烈推荐所有用户以学术研究的心态来阅读和学习相关内容。',
  },
  {
    question: '如何参与或贡献内容？',
    answer: '我们欢迎有学术背景或专业知识的用户参与内容贡献。您可以通过"关于我们"页面的联系方式与我们取得联系，提交您的研究成果或文章提案。我们的编辑团队会认真评估每一份投稿并给予反馈。',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqItems.map((item) => ({
      '@type': 'Question',
      name: item.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.answer,
      },
    })),
  };

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
      <div className="px-4 md:px-6 max-w-3xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
            常见问题解答
          </h2>
          <p className="text-sm md:text-base text-foreground-600 mt-3">
            关于 hitozuma 文化及本网站的常见疑问，在这里找到答案
          </p>
        </div>

        <div className="flex flex-col gap-3">
          {faqItems.map((item, index) => (
            <div
              key={index}
              className="rounded-xl bg-background-50 border border-background-200/60 overflow-hidden"
            >
              <button
                onClick={() => toggle(index)}
                className="w-full flex items-center justify-between p-5 text-left cursor-pointer hover:bg-background-100 transition-colors"
              >
                <span className="text-sm md:text-base font-medium text-foreground-800 pr-4">
                  {item.question}
                </span>
                <div className={`w-5 h-5 flex-shrink-0 flex items-center justify-center transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`}>
                  <i className="ri-arrow-down-s-line text-foreground-500"></i>
                </div>
              </button>
              {openIndex === index && (
                <div className="px-5 pb-5">
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {item.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}